<template>
    <div>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="8" :xl="8">
                <pay class="m-b-20"></pay>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" :xl="8">
                <el-card class="el-card--with-table m-b-20 p-b-20 min-height-220">
                    <div slot="header">
                        <h2 class="m-b-0">Карты</h2>
                    </div>
                    <cards></cards>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" :xl="8">
                <el-card class="el-card--with-table m-b-20 p-b-20 min-height-220">
                    <div slot="header">
                        <h2 class="m-b-0">Автомобили</h2>
                    </div>
                    <cars></cars>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <events></events>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import cards from '@/views/pages/client/cards'
import cars from '@/views/pages/client/cars'
import pay from '@/views/pages/pay/'
import events from '@/views/pages/reports/events'

export default {
    components: { cards, cars, pay, events },
    name: "index"
}
</script>

<style scoped>

</style>
